export default "__VITE_ASSET__C2YL6zYd__"